<template>
    <landlords-current
        v-slot="{
            data: landlord
        }"
    >
        <with-variables
            :variables="{
                contact: _.get(jobSheet, 'contacts.data[0]')
            }"
            v-slot="{ contact }"
        >
            <div>
                <base-svg
                    name="icon-comment"
                    class="absolute top-0 left-0 w-6 h-6"
                    :class="{
                        'fill-primary-blue fill-secondary-blue-lighter': _.isNull(entry.persona)
                    }"
                />

                <header>
                    <h6>
                        <template v-if="landlord">
                            <template v-if="entry.persona && entry.persona.type === landlord.type && landlord.uuid === entry.persona.uuid">
                                You
                            </template>
                            <template v-else>
                                {{ contact.name }}
                            </template>
                        </template>
                        <template v-else>
                            {{ _.get(entry, 'persona.first_name', 'You') }}
                        </template>
                        left a comment
                    </h6>

                    <span class="text-label">{{ entry.created_at | moment('HH:mm:ss DD/MM/YYYY') }}</span>
                </header>

                <div
                    v-if="entry.text"
                    class="mt-1 text-grey-darker"
                >
                    <base-expandable>
                        <template v-slot:short>
                            <div class="whitespace-pre-wrap">{{ entry.text | limit(300) }}</div>
                        </template>

                        <template v-slot:long>
                            <div class="whitespace-pre-wrap">{{ entry.text }}</div>
                        </template>

                        <template v-slot:trigger="{ isOpen: is_open, toggle }">
                            <button
                                v-if="_.truncate(entry.text, { length: 300 }) < entry.text"
                                class="inline-flex items-center mt-1 text-blue focus:outline-none"
                                @click.prevent="toggle"
                            >
                                Read {{ is_open ? 'less' : 'more' }}

                                <base-svg
                                    :name="`icon-cheveron-${is_open ? 'up' : 'down'}`"
                                    :key="`icon-cheveron-${is_open ? 'up' : 'down'}`"
                                    class="w-5 h-5 fill-primary-blue"
                                />
                            </button>
                        </template>
                    </base-expandable>
                </div>
            </div>
        </with-variables>
    </landlords-current>
</template>

<script>
    import LandlordsCurrent from './landlords-current'

    export default {
        components: {
            LandlordsCurrent
        },
        props: {
            entry: {
                type: Object,
                required: true
            },
            jobSheet: {
                type: Object,
                required: true
            }
        }
    }
</script>
